import { controller, target } from '@github/catalyst'
import { type TurboSubmitEndEvent } from '@hotwired/turbo'

@controller
export class FormDialogElement extends HTMLElement {
  @target form: HTMLFormElement
  @target dialog: HTMLDialogElement
  @target closeButton: HTMLButtonElement

  #abortController: AbortController

  connectedCallback() {
    const {signal} = (this.#abortController = new AbortController())
    this.addEventListener('turbo:submit-end', this, {signal})
    this.addEventListener('click', this, {signal})
  }

  disconnectedCallback() {
    this.#abortController.abort()
  }

  handleEvent(event: Event) {
    if (event.target === this.form) {
      this.#handleFormEvent(event)
    } else if ((event.target as HTMLElement).closest('button') === this.closeButton) {
      this.#handleCloseButtonEvent(event)
    }
  }

  #handleFormEvent(event: Event) {
    if (event.type !== 'turbo:submit-end') return

    const submitEvent = event as TurboSubmitEndEvent

    if (submitEvent.detail.success) {
      this.dialog.close()
    }
  }

  #handleCloseButtonEvent(event: Event) {
    if (event.type !== 'click') return

    this.dialog.close()
  }
}

declare global {
  interface Window {
    FormDialogElement: typeof FormDialogElement
  }

  interface HTMLElementTagNameMap {
    'form-dialog': FormDialogElement
  }
}

if (!window.customElements.get('form-dialog')) {
  window.FormDialogElement = FormDialogElement
  window.customElements.define('form-dialog', FormDialogElement)
}
